// Mayasurts sticky add-to-cart: shows only while the main ATC is scrolled out of view.
class MayaStickyAtc extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section') || document;
    this.form = this.section.querySelector('product-form-component');
    this.mainBtn = this.form?.querySelector('button[type="submit"], .add-to-cart-button');
    if (!this.mainBtn) return;

    this.btn = this.querySelector('[data-satc-btn]');
    this.btn.addEventListener('click', () => this.mainBtn.click());
    this.querySelector('[data-satc-change]')?.addEventListener('click', (e) => {
      e.preventDefault();
      const picker = this.section.querySelector('variant-picker, .variant-picker') || this.form;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // Visibility: ATC above the viewport (scrolled past) and footer not on screen
    this.atcPast = false;
    this.footerIn = false;
    this.io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.target === this.mainBtn) this.atcPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        else this.footerIn = e.isIntersecting;
      }
      this.update();
    });
    this.io.observe(this.mainBtn);
    const footer = document.querySelector('footer, .shopify-section-group-footer-group');
    if (footer) this.io.observe(footer);

    // Keep disabled state in sync with the real button (sold out / unavailable)
    this.mo = new MutationObserver(() => this.syncFromMain());
    this.mo.observe(this.mainBtn, { attributes: true, attributeFilter: ['disabled'] });

    // Variant changes: title, image, price
    this.onVariant = (e) => {
      const v = e.detail?.resource;
      if (v) {
        const vt = this.querySelector('[data-satc-variant]');
        if (vt && v.title) vt.textContent = v.title;
        const src = v.featured_media?.preview_image?.src || v.featured_image?.src;
        const img = this.querySelector('[data-satc-img]');
        if (img && src) { img.removeAttribute('srcset'); img.src = src + (src.includes('?') ? '&' : '?') + 'width=120'; }
      }
      // let the theme render the new price first, then mirror it
      setTimeout(() => this.syncFromMain(), 120);
    };
    document.addEventListener('variant:update', this.onVariant);
  }

  disconnectedCallback() {
    this.io?.disconnect();
    this.mo?.disconnect();
    document.removeEventListener('variant:update', this.onVariant);
  }

  syncFromMain() {
    this.btn.disabled = this.mainBtn.disabled;
    const price = this.section.querySelector('product-price .price, product-price [ref="priceContainer"] .price');
    const out = this.querySelector('[data-satc-price]');
    if (price && out && price.textContent.trim()) out.textContent = price.textContent.trim().replace(/\s+[A-Z]{3}$/, '');
  }

  update() {
    const show = this.atcPast && !this.footerIn;
    this.classList.toggle('is-visible', show);
    this.toggleAttribute('inert', !show);
    this.setAttribute('aria-hidden', String(!show));
  }
}

if (!customElements.get('maya-sticky-atc')) customElements.define('maya-sticky-atc', MayaStickyAtc);
